// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!../../components/library/style/breakpoint.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!../../components/library/style/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XfsPayzA7bqHkaKciNs_ {
  margin: 140px auto;
  width: 100%;
}

.N8Ad1QiTCf2vFeo9kKAs {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: auto;
  margin-bottom: 16px;
  margin-top: 80px;
  max-width: 1440px;
}

.l6J79Veh8GgycU7o_RXr {
  position: relative;
  background-color: white;
  padding-bottom: 20px;
}

.sKfJKgPlYs6a4_OLlNab {
  display: none;
}

.eQlW9nQiyno7eOtJ96MN {
  position: absolute;    
  inset: 40px;
  width: 100%;
  height: 100%;
  margin: auto;
  padding: 40px;
  outline: none;
  overflow: auto;
  max-width: 625px;
  max-height: 600px;
  border-radius: 10px;
  background: rgb(255, 255, 255);
}

.eQlW9nQiyno7eOtJ96MN.kIVf76oy0xiBHVAPSX4A {
  max-width: 1050px;
  max-height: 750px;
  padding-top: 0;
  padding-bottom: 0;
}

.ZtN0_9YQVkqaDny4u1gR {
  z-index: 1000;
  position: fixed;
  inset: 0px;
  background-color: rgba(0, 0, 0, 0.4);
}

@media screen and (max-width: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["tablet-l"]}) {
  .XfsPayzA7bqHkaKciNs_ {
    width: 95%;
  }

  .eQlW9nQiyno7eOtJ96MN {
    inset: 0;
    padding: 10px;
    max-height: 70vh;
    max-width: 90vw;
  }

  .sKfJKgPlYs6a4_OLlNab {
    display: block;
  }
}`, "",{"version":3,"sources":["webpack://./src/views/Eligible/Eligible.module.css"],"names":[],"mappings":"AAOA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,QAAQ;IACR,aAAa;IACb,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":["@value breakpoints: \"components/library/style/breakpoint.css\";\n@value tablet-l from breakpoints;\n\n@value colors: \"components/library/style/colors.css\";\n@value color-text, color-purple from colors;\n\n\n.content {\n  margin: 140px auto;\n  width: 100%;\n}\n\n.simulationContainer {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  margin: auto;\n  margin-bottom: 16px;\n  margin-top: 80px;\n  max-width: 1440px;\n}\n\n.backgroundWhite {\n  position: relative;\n  background-color: white;\n  padding-bottom: 20px;\n}\n\n.mobile {\n  display: none;\n}\n\n.modal {\n  position: absolute;    \n  inset: 40px;\n  width: 100%;\n  height: 100%;\n  margin: auto;\n  padding: 40px;\n  outline: none;\n  overflow: auto;\n  max-width: 625px;\n  max-height: 600px;\n  border-radius: 10px;\n  background: rgb(255, 255, 255);\n}\n\n.modal.largeModal {\n  max-width: 1050px;\n  max-height: 750px;\n  padding-top: 0;\n  padding-bottom: 0;\n}\n\n.modalOverlay {\n  z-index: 1000;\n  position: fixed;\n  inset: 0px;\n  background-color: rgba(0, 0, 0, 0.4);\n}\n\n@media screen and (max-width: tablet-l) {\n  .content {\n    width: 95%;\n  }\n\n  .modal {\n    inset: 0;\n    padding: 10px;\n    max-height: 70vh;\n    max-width: 90vw;\n  }\n\n  .mobile {\n    display: block;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"breakpoints": `"components/library/style/breakpoint.css"`,
	"tablet-l": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["tablet-l"]}`,
	"colors": `"components/library/style/colors.css"`,
	"color-text": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-text"]}`,
	"color-purple": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-purple"]}`,
	"content": `XfsPayzA7bqHkaKciNs_`,
	"simulationContainer": `N8Ad1QiTCf2vFeo9kKAs`,
	"backgroundWhite": `l6J79Veh8GgycU7o_RXr`,
	"mobile": `sKfJKgPlYs6a4_OLlNab`,
	"modal": `eQlW9nQiyno7eOtJ96MN`,
	"largeModal": `kIVf76oy0xiBHVAPSX4A`,
	"modalOverlay": `ZtN0_9YQVkqaDny4u1gR`
};
export default ___CSS_LOADER_EXPORT___;
